export const ActivityData = [{}];

export const sortingMethod = (val: any) => {
  let sortedVal = val.sort((a: any, b: any) => {
    return new Date(a.key).valueOf() - new Date(b.key).valueOf();
  });
  return sortedVal;
};

export const DownloadReportsTypes = {
  Login: "LOGIN",
  Order: "ORDER",
  Trade: "TRADE",
  All: "ALL",
};

export interface DBStatistics {
  key: string;
  val: string;
}
export const DashboardViewOptios = {
  Weekly: "weekly",
  Daily: "daily",
};

export const isDacimal = (value: string) => {
  if (value !== undefined && value !== null && value !== "") {
    let result = parseFloat(value);
    if (!Number.isInteger(result) && result > 0 && value !== undefined) {
      return result.toFixed(2);
    } else {
      return result;
    }
  } else {
    return 0;
  }
};

// Details :

//  @ApiModelProperty("Vendor name")
//     private String vndNm;
//     @ApiModelProperty("Status")
//     private String sts;
//     @ApiModelProperty("Reason of suspension")
//     private String ros;
//     @ApiModelProperty("Total Client Login")
//     private String ntClntLgn;
//     @ApiModelProperty("Unique client login")
//     private String unqClntLgn;
//     @ApiModelProperty("Unique client login percent")
//     private String unqClntLgnPr;
//     @ApiModelProperty("Clients Accepted Consent")
//     private String clntAcptCnsnt;
//     @ApiModelProperty("Clients Declined Consent")
//     private String clntDecCnsnt;
//     @ApiModelProperty("Unique client ordered")
//     private String unqClntOrd;
//     @ApiModelProperty("Unique client traded")
//     private String unqClntTrd;
//     @ApiModelProperty("Unique client Trade percent")
//     private String unqClnTrdPr;
//     @ApiModelProperty("Total orders Placed")
//     private String ntOrd;
//     @ApiModelProperty("Total executed orders")
//     private String ntTrds;
//     @ApiModelProperty("Total number of trade packets (including partial trades)")
//     private String ntFlTrds;
//     @ApiModelProperty("Login count vs date")
//     private List<EdelApiKeyValueObject> lgnChrt;
//     @ApiModelProperty("Unique client Order vs date")
//     private List<EdelApiKeyValueObject> unqClntOrdCht;
//     @ApiModelProperty("Unique client Trade vs date")
//     private List<EdelApiKeyValueObject> unqClntTrdCht;
//     @ApiModelProperty("Order count exchange wise")
//     private List<EdelApiKeyValueObject> ordsExcWise;
//     @ApiModelProperty("Trade count exchange wise")
//     private List<EdelApiKeyValueObject> trdsExcWise;
//     @ApiModelProperty("Order to Trade Ratio vs date")
//     private List<EdelApiKeyValueObject> ordTradeRtoCht;
//     @ApiModelProperty("Total Order to Trade Ratio vs Exchange")
//     private List<EdelApiKeyValueObject> ntOrdTrdRtoExchWiseCht;
//     @ApiModelProperty("Top Sales Date vs Total for trade only Segment wise")
//     private List<EdelApiKeyValueObject> topSls;
//     @ApiModelProperty("Order Volume Stats segment wise")
//     private List<EdelApiKeyValueObject> ordVolStats;
//     @ApiModelProperty("Trade Volume Stats segment wise")
//     private List<EdelApiKeyValueObject> trdVolStats;
//     @ApiModelProperty("Order Volume Heat map Segment wise ")
//     private List<VolumeHeatMapObject> ordVolHtMap;
//     @ApiModelProperty("Trade Volume Heat map Segment wise")
//     private List<VolumeHeatMapObject> trdVolHtMap;
//     @ApiModelProperty("Top Order Volume Leaders")
//     private List<VendorVolumeLeadersObject> topOrdVolLdrsSegWise;
//     @ApiModelProperty("Top Trade Volume Leaders")
//     private List<VendorVolumeLeadersObject> topTrdVolLdrsSegWise;
//     @ApiModelProperty("Net APi Hit count ")
//     private List<EdelApiKeyValueObject> ntApiHitCountCht;
//     @ApiModelProperty("Earnings segment wise ")
//     private List<EdelApiKeyValueObject> erngsSegWise;
//     @ApiModelProperty("Earnings chart ")
//     private List<EdelApiKeyValueObject> erngsCht;
//     @ApiModelProperty("My Info")
//     private VendorSubscriptionMyInfoObject myInfo;
